import React from "react";

const TabTitle = (props) => {
  return (
    <div className="tabTitle">
      <input
        type="radio"
        className="tabTitle__option"
        id={props.id}
        checked={props.defaultChecked}
        name="tabs"
        value={props.value}
        disabled={props.disabled ? props.disabled : false}
      />
      <label
        htmlFor={props.id}
        className="tabTitle__label"
        onClick={props.onClick}
      >
        {props.id}
      </label>
    </div>
  );
};
export default TabTitle;
